import { render, staticRenderFns } from "./ClientProfileStatements.vue?vue&type=template&id=7ea8c740&scoped=true&"
import script from "./ClientProfileStatements.vue?vue&type=script&lang=js&"
export * from "./ClientProfileStatements.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileStatements.vue?vue&type=style&index=0&id=7ea8c740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea8c740",
  null
  
)

export default component.exports